import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import produce, { Draft } from "immer";
import Top100ItemsState from "@galarson/Store/Top100Items/Top100ItemsState";
import { GetTop100ItemsApiParameter } from "@galarson/Handlers/Top100Items/Top100ItemsService";
const initialState: Top100ItemsState = {
    getTop100ItemsApiParameter: {
        sort: "TimesOrdered",
        customerNumber:""
    },
    isLoading: false,
    top100Items:[]
};

const reducer = {
    "Data/Top100Items/BeginLoadItems": (
        draft: Draft<Top100ItemsState>,
        action: { parameter: GetTop100ItemsApiParameter },
    ) => {
        draft.getTop100ItemsApiParameter = action.parameter;
        draft.isLoading = true;
    },
    "Data/Top100Items/CompletedLoadItems": (draft: Draft<Top100ItemsState>,  action: {
        collection: any; parameter: GetTop100ItemsApiParameter & UpdateSearchFieldsType 
},) => {
    
         const [property, order] = action.parameter.sort.split(" ");
         const sortedData = [...action?.collection?.top100Items];
         sortedData.sort((a, b) => {
             if (a[property] < b[property]) {
                 return order === 'desc' ? 1 : -1;
             }
             if (a[property] > b[property]) {
                 return order === 'desc' ? -1 : 1;
             }
             return 0;
         });
     
        draft.isLoading = false;
        draft.top100Items = sortedData

    }
};

export default createTypedReducerWithImmer(initialState, reducer);
